"use client";

import React from "react";

export const HeroAnimation = () => {
    return (
        <div className="absolute inset-0 pointer-events-none -z-10 overflow-hidden flex items-center justify-center translate-y-[-20%] md:translate-y-[-10%]">
            <svg
                viewBox="0 0 1 1"
                className="w-full h-full max-w-[1400px] max-h-[1400px] opacity-80"
                preserveAspectRatio="xMidYMid slice"
                style={{
                    overflow: "visible"
                }}
            >
                {/* 
                  Path logic: An ellipse centered at 0.5, 0.5.
                  d="M 0.5, 0.5 m -0.2, 0 a 0.2,0.45 0 1,0 0.4,0 a 0.2,0.45 0 1,0 -0.4,0"
                  Wait, the previous path was slightly simpler: M0.3,0.5a0.2,0.45... which starts at left edge.
                  Let's use a standard ellipse path that is centered.
                  Center: 0.5, 0.5
                  Rx: 0.2
                  Ry: 0.45
                */}

                {/* Path 1: Blue Light (0deg) */}
                <path
                    d="M0.3,0.5a0.2,0.45 0 1,0 0.4,0a0.2,0.45 0 1,0 -0.4,0"
                    fill="none"
                    stroke="#D6E4FF"
                    strokeWidth="0.03"
                    strokeLinecap="round"
                    strokeDasharray="0.42 1.7"
                    className="origin-center"
                    style={{
                        animation: "draw 20s linear infinite",
                        transformOrigin: "center center",
                    }}
                />

                {/* Path 2: Blue Medium (120deg) */}
                <path
                    d="M0.3,0.5a0.2,0.45 0 1,0 0.4,0a0.2,0.45 0 1,0 -0.4,0"
                    fill="none"
                    stroke="#AEC6FF"
                    strokeWidth="0.03"
                    strokeLinecap="round"
                    strokeDasharray="0.42 1.7"
                    className="origin-center"
                    style={{
                        animation: "draw 20s linear infinite",
                        transformOrigin: "center center",
                        transform: "rotate(120deg)",
                    }}
                />

                {/* Path 3: Blue Darker (240deg) */}
                <path
                    d="M0.3,0.5a0.2,0.45 0 1,0 0.4,0a0.2,0.45 0 1,0 -0.4,0"
                    fill="none"
                    stroke="#8FB5FF"
                    strokeWidth="0.03"
                    strokeLinecap="round"
                    strokeDasharray="0.42 1.7"
                    className="origin-center"
                    style={{
                        animation: "draw 20s linear infinite",
                        transformOrigin: "center center",
                        transform: "rotate(240deg)",
                    }}
                />
            </svg>
        </div>
    );
};
